import { push } from 'connected-react-router';
import CoreAPIService from '../../../utils/core-api';
import ObjectUtils from '../../../utils/objectUtils';
import { fetchAction } from '../../actions';
import { VehicleById, VehicleTypeById, VehicleEditPayload, VehicleTypeDetails } from '../api-types';
import { paths } from '../../../routes/paths';
import { name, types } from './actionTypes';
import { handleVehicleDocuments } from './utils';

interface VehiclesState {
    vehicles: VehicleById;
    vehicleTypes: VehicleTypeById; //TODO rename model not type
    types: VehicleTypeDetails[];
}

const initialState: VehiclesState = {
    vehicles: {} as VehicleById,
    vehicleTypes: {} as VehicleTypeById,
    types: [],
};
const reducer = (state = initialState, action): VehiclesState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;
    const enable = parameters ? parameters.enable : 0;
    switch (action.type) {
        case types.GET_VEHICLE:
            action = {
                ...action,
                payload: {
                    ...payload,
                    documents: ObjectUtils.keepIds(payload.documents),
                },
            };
            return {
                ...state,
                vehicles: { ...state.vehicles, [id]: action.payload },
            };
        case types.EDIT_VEHICLE:
            return {
                ...state,
                vehicles: {
                    ...state.vehicles,
                    [id]: {
                        ...state.vehicles[id],
                        ...payload,
                    },
                },
            };
        case types.SET_ENABLE:
            return {
                ...state,
                vehicles: {
                    ...state.vehicles,
                    [id]: {
                        ...state.vehicles[id],
                        deletion_date: enable ? null : Date.now() / 1000,
                    },
                },
            };
        case types.GET_VEHICLE_TYPE:
            return {
                ...state,
                vehicleTypes: {
                    ...state.vehicleTypes,
                    [id]: {
                        ...payload,
                        brand: payload.brand?.name || '',
                        model: payload.localized_string?.fr || '',
                        age_max: payload.max_age || null,
                        ...Object.fromEntries(
                            ['Van', 'Berline', 'Green', 'Moto', 'Exec', 'Access'].map((type) => [
                                `is${type}`,
                                payload.type?.localized_name?.fr?.includes(type) || false,
                            ]),
                        ),
                        age_inf_berline: payload.dispatch_groups?.[0]?.max_eligibility_age || null,
                    },
                },
            };
        case types.SAVE_VEHICLE_TYPE:
            return {
                ...state,
                vehicleTypes: {
                    ...state.vehicleTypes,
                    [id]: null,
                },
            };
        case types.GET_VEHICLE_TYPES:
            return {
                ...state,
                types: payload,
            };
        case types.GET_VEHICLE:
            return handleVehicleDocuments(state, action);
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getVehicle: (id) => fetchAction(CoreAPIService.get(`/core/vehicles/${id}`), types.GET_VEHICLE, { id }),
    editVehicle: (id, payload: VehicleEditPayload) =>
        fetchAction(
            CoreAPIService.put(`/core/vehicles/${id}`, payload),
            types.EDIT_VEHICLE,
            { id },
            {
                success: (dispatch) => {
                    dispatch(push(`${paths.vehicles}/${id}`));
                },
            },
        ),
    setEnable: (id, enable, payload) =>
        fetchAction(
            enable
                ? CoreAPIService.put(`/core/vehicles/${id}?enable=${enable}`, payload)
                : CoreAPIService.delete(`/core/vehicles/${id}`, payload),
            types.SET_ENABLE,
            { id, enable },
        ),
    getVehicleType: (id) =>
        fetchAction(CoreAPIService.get(`/core/vehicles/models/${id}`), types.GET_VEHICLE_TYPE, { id }),
    getVehicleTypes: () => fetchAction(CoreAPIService.get(`/core/vehicles/types`), types.GET_VEHICLE_TYPES, {}),
    saveVehicleType: (payload) =>
        fetchAction(
            CoreAPIService.post(`/core/vehicles/types`, payload),
            types.SAVE_VEHICLE_TYPE,
            { payload },
            {
                success: (dispatch) => {
                    dispatch(push(paths.vehiclesTypes));
                },
            },
        ),
};

const localState = (state: any): VehiclesState => state[name] || initialState;
export const selectors = {
    types: (state) => localState(state).types,
    vehicles: (state) => localState(state).vehicles,
    vehicleTypes: (state) => localState(state).vehicleTypes,
};
